import { getZonaEntidad } from "./Agenda";

// Año en curso en la zona horaria de la clínica (la de la entidad emisora, con la provincia de la clínica si es de su
// país), no en la del navegador: la serie de facturación lleva el año y el servidor lo calcula con esta misma regla
// (API/src/utils/fechas.ts -> getAnioEnCurso) — mantenerlas iguales.
export const getAnioEnCurso = (pais?: string, ahora: Date = new Date()): number =>
  Number(new Intl.DateTimeFormat("en-CA", { timeZone: getZonaEntidad(pais), year: "numeric" }).format(ahora));
